import { render, staticRenderFns } from "./OptionalTripForm.vue?vue&type=template&id=1c14c37a&scoped=true"
import script from "./OptionalTripForm.vue?vue&type=script&lang=ts"
export * from "./OptionalTripForm.vue?vue&type=script&lang=ts"
import style0 from "./OptionalTripForm.vue?vue&type=style&index=0&id=1c14c37a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c14c37a",
  null
  
)

export default component.exports